import SuperRepository from '../superRepository'

export default new (class OfferRepository extends SuperRepository {
  baseUri() {
    return 'offer'
  }

  activate = (id, active) => this.httpClient().put(`${this.baseUri()}/activate/${id}?activate=${active.active}`)
})()
